import React, { useState } from 'react';
import './Header.scss';

import { isBrowser } from "react-device-detect"
import { useNavigate } from 'react-router-dom';

import { Container, Nav, Navbar, Collapse, NavbarToggler, NavbarBrand, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import logo from '../../assets/logo.png';
import reactLogo from '../../assets/react-logo.png'
import TabButton from '../TabButton';

import menuButton from '../../assets/threelines.png'

const Header = ({ routes }) => {
  const [isOpen, setOpen] = useState(false)
  const navigate = useNavigate();

  return (
    <Navbar color="dark" dark expand="md">
      <Container>
        <NavbarBrand href="/"><img src={logo} style={{ width: "6vh" }} alt="logo" /></NavbarBrand>
        <NavbarToggler onClick={() => setOpen(!isOpen)} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar>
            {routes.map(({ name, to, exact, showOnTabBar }, i) => showOnTabBar && (
              <NavItem>
                <NavLink href={to}>{name}</NavLink>
              </NavItem>
            ))}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  )
}

export { Header }

export default Header;